// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"35770596","455":"fb54983e","977":"a2794ad1"}[chunkId] + ".chunk.js";
};